import {useContext} from "react";
import {YStack, Button} from "@chayka/ui";
import type {BookingWizardSlideComponent} from "./types";
import {BookingStateContext} from "../state";
import {useNavigate} from "react-router-dom";
import {showSuccessToast} from "@/utils/toast";

export const SuccessSlide: BookingWizardSlideComponent = () => {
  const {reset, hasToBeConfirmed} = useContext(BookingStateContext);
  const navigate = useNavigate();

  const handleOk = () => {
    navigate("/app/my-bookings", {replace: true});
    reset();
    showSuccessToast("Успех!");
  };

  return (
    <YStack className="h-full justify-center align-middle text-center gap-10">
      <h2 className="text-3xl font-light">
        {hasToBeConfirmed ? "Ваш заказ принят!" : "Бронирование успешно создано!"}
      </h2>
      <div className="text-secondary-text">
        {hasToBeConfirmed
          ? `В ближайшее время с Вами свяжется администратор студии для обработки данных и подтверждения заказа.`
          : `Теперь администратору нужно подтвердить бронирование, но время уже
        зарезервировано за вами. Отмена бесплатна за 48 часов до начала занятия.`}
      </div>
      <Button onClick={handleOk}>Хорошо</Button>
    </YStack>
  );
};
